import { jsx as _jsx } from "react/jsx-runtime";
import { HomeVideosItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = (props) => _jsx(HomeVideosItem, { isAdd: true, ...props });
export default Add;
